import { render } from "./ContactPage.vue?vue&type=template&id=033a69df&scoped=true"
const script = {}

import "./ContactPage.vue?vue&type=style&index=0&id=033a69df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033a69df"]])

export default __exports__